import React from 'react';
import "tabulator-tables/dist/css/tabulator_semanticui.css";
import parse from 'html-react-parser';
import TabulatorSoftdata from './TabulatorSoftdata';
import TableToExcel from './TableToExcel';
import { getTextWidth } from "get-text-width";
import { DEBUG } from '../config';


class DatatableReports extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            studyName: props.studyName,
            nomeQuadro: props.nomeQuadro,
            dataTypeName: props.dataTypeName,
            column: props.column,
            data: props.data,
            media: props.media,
            nps: props.nps,
            textoBase: props.textoBase,
            textoNota: props.textoNota,
            columnDefs: [],
            rowData: [],
            columns: [],
            precision: props.precision,
            displayTable: false,
            height: 0,
            tabulator: null,
            topColumn: "",
        };

        this.initializeState = this.initializeState.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.componentDidUpdate = this.componentDidUpdate.bind(this);
        this.buildTableData = this.buildTableData.bind(this);
        this.setColumnDefs = this.setColumnDefs.bind(this);
    }

    setColumnDefs(rowDataLocal) { // Recebe os dados por parâmetro
        var rows = this.props.data;

        if (!rows || rows.length === 0) return { columnDefs: [], columns: [], topColumn: "" };

        var columnsNoTotal = rows[0].reportResultsByColumn ? rows[0].reportResultsByColumn.filter((c) => String(c.coluna).toUpperCase().trim() !== 'TOTAL') : [];
        var topColumn = rows[0].coluna;
        var columnArray = [];

        var rowBase = rowDataLocal ? rowDataLocal.find((r) => r.lineName === 'Base') : null; // Usa a variável local
        var columnMinWidth = 0;

        for (let i = 0; i < columnsNoTotal.length; i++) {
            const colKey = "col" + (i + 2);
            if (rowBase && rowBase[colKey]) {
                var columnWidthLength = getTextWidth(String(rowBase[colKey]));
                if (columnWidthLength > columnMinWidth) {
                    columnMinWidth = columnWidthLength;
                }
            }
        }

        var colTitlesBR = [];
        for (let i = 0; i < columnsNoTotal.length; i++) {
            var column = columnsNoTotal[i].coluna;
            var prevS = '';
            while (prevS !== column) {
                prevS = column; column = column.replace(/([0-9]+) ([0-9]+)/, '$1_$2');
            }
            var pos = 0;
            var finalColumnString = "";
            var wordLength = 0;
            var auxWord = "";
            while (column.length > 0) {
                pos = column.indexOf(" ");
                if (pos < 14) {
                    var auxLength = 0;
                    var auxLine = "";
                    var auxLineWidth = 0;
                    while ((pos !== -1) && (pos < 14) && (auxLength < 14)) {
                        auxLine += column.substring(0, pos) + " ";
                        auxLength += pos + 1;
                        auxLineWidth = getTextWidth(auxLine);
                        if (auxLineWidth > columnMinWidth) {
                            columnMinWidth = auxLineWidth;
                        }
                        column = column.substring(pos + 1, column.length);
                        pos = column.indexOf(" ");
                    }
                    if (pos === -1 || auxLength >= 14) {
                        auxLineWidth = getTextWidth(auxLine);
                        if (auxLineWidth > columnMinWidth) {
                            columnMinWidth = auxLineWidth;
                        }
                        auxLineWidth = getTextWidth(column);
                        if (auxLineWidth > columnMinWidth) {
                            columnMinWidth = auxLineWidth;
                        }
                        if (auxLength >= 14) {
                            auxLine += "<BR/>";
                        }
                        auxLine += column;
                    }
                    finalColumnString += auxLine;
                    break;

                } else if (pos >= 14) {
                    finalColumnString += column.substring(0, pos) + "<BR/>";
                    auxWord = finalColumnString.replaceAll("<BR/>", "_");
                    wordLength = getTextWidth(auxWord.substring(0, pos));
                    if (wordLength > columnMinWidth) {
                        columnMinWidth = wordLength;
                    }
                    column = column.substring(pos + 1, column.length);
                }
            }
            colTitlesBR[i] = finalColumnString.replaceAll('_', '&nbsp;');
        }
        columnMinWidth = columnMinWidth * 0.6;
        for (let i = 0; i < columnsNoTotal.length; i++) {
            columnArray[i] = {
                title: colTitlesBR[i],
                field: "col" + (i + 2), headerSort: false,
                headerHozAlign: "center",
                hozAlign: "center",
                minWidth: columnMinWidth,
            };
        }

        var maxLineLenght = 0;
        if (rowDataLocal && rowDataLocal.length > 0) { // Usa a variável local
            maxLineLenght = Math.max(...rowDataLocal.map(l => getTextWidth(l.lineName || "")));
        }
        maxLineLenght = maxLineLenght * 0.75;

        var columnDefs = [
            { title: "", field: "lineName", headerSort: false, minWidth: maxLineLenght, frozen: true }
        ];

        // Vai procurar se a coluna TOTAL existe em ALGUMA das linhas, e não apenas na primeira!
        var columnTotal = rows.some(r => r.reportResultsByColumn && r.reportResultsByColumn.find(c => String(c.coluna).toUpperCase().trim() === 'TOTAL')) ? true : null;
        var colIndex = 1;

        if (typeof columnTotal !== 'undefined' && columnTotal !== null) {
            if (rowBase && rowBase["totalCol"]) {
                columnMinWidth = getTextWidth(String(rowBase["totalCol"]));
            } else {
                columnMinWidth = 50;
            }

            var totalWidth = getTextWidth("Total");
            if (totalWidth > columnMinWidth) {
                columnMinWidth = totalWidth;
            }
            columnDefs[colIndex] = {
                title: "Total",
                field: "totalCol",
                headerSort: false,
                headerHozAlign: "center",
                hozAlign: "center",
                minWidth: totalWidth,
                width: columnMinWidth,
                frozen: true
            };
        }

        if (typeof topColumn === 'undefined' || topColumn === null) {
            topColumn = "";
        }

        if (columnArray.length > 0) {
            columnDefs[colIndex + 1] = {
                title: `${topColumn}`,
                headerHozAlign: "center",
                columns: columnArray,
                formatter: "textarea",
                width: "100%",
                minWidth: columnMinWidth * 1.5,
            };
        }

        return { columnDefs: columnDefs, columns: columnArray, topColumn: topColumn }; // Retorna tudo embrulhadinho
    }

    buildTableData() {
        var rows = this.props.data; // Ler das props
        if (DEBUG){
            console.log("1. [Datatables, DatatablesReport, buildTableData] DADOS BRUTOS DO JAVA:", rows);
        }
        var rowsAux = [];
        var result;
        var colFieldIndex;

        if (!rows || rows.length === 0) return [];

        for (let i = 0; i < rows.length; i++) {
            const newRow = { "id": i + 1 };
            newRow["lineName"] = rows[i].linha;

            if (!rows[i] || !rows[i].reportResultsByColumn) continue;

            var columnsAux = rows[i].reportResultsByColumn;
            var columnTotal = columnsAux.find((c) => String(c.coluna).toUpperCase().trim() === 'TOTAL');

            if (typeof columnTotal !== 'undefined') {
                let valueTotal = 0;
                if (this.props.dataTypeName === 'Percentagens verticais (%)' || this.props.dataTypeName === 'Valores médios') {
                    valueTotal = columnTotal.pv;
                } else if (this.props.dataTypeName === 'Percentagens horizontais (%)') {
                    valueTotal = columnTotal.ph;
                } else {
                    valueTotal = columnTotal.valorBase; 
                }

                if (this.props.dataTypeName === 'Valores médios') {
                    newRow["totalCol"] = Intl.NumberFormat('pt-PT', { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(valueTotal || 0).toFixed(2));
                } else {
                    // Agora usa a precisão correta do quadro e formata o valor certo!
                    newRow["totalCol"] = Intl.NumberFormat('pt-PT', { useGrouping: true, minimumFractionDigits: this.props.precision }).format(parseFloat(valueTotal || 0).toFixed(this.props.precision));
                }
            }
            var columnAuxNoTotal = columnsAux.filter((c) => String(c.coluna).toUpperCase().trim() !== 'TOTAL');             
            for (let j = 0; j < columnAuxNoTotal.length; j++) {
                colFieldIndex = "col" + (j + 2);
                var value = 0;
                if (this.props.dataTypeName === 'Percentagens verticais (%)' || this.props.dataTypeName === 'Valores médios') {
                    value = columnAuxNoTotal[j].pv;
                } else if (this.props.dataTypeName === 'Percentagens horizontais (%)') {
                    value = columnAuxNoTotal[j].ph;
                } else {
                    value = columnAuxNoTotal[j].valorBase;
                }
                
                if (this.props.dataTypeName === 'Valores médios') {
                    result = parseFloat(value || 0).toFixed(2);
                    newRow[colFieldIndex] = Intl.NumberFormat('pt-PT', { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(result);
                } else {
                    result = parseFloat(value || 0).toFixed(this.props.precision);
                    newRow[colFieldIndex] = Intl.NumberFormat('pt-PT', { useGrouping: true, minimumFractionDigits: 1 }).format(result);
                }
            }
            rowsAux[i] = newRow;
        }

        var index = rowsAux.length;
        var row0 = this.props.data[0]; // Ler das props

        if (!row0 || !row0.reportResultsByColumn) return rowsAux;

        var colsRow0 = row0.reportResultsByColumn;
        var colTotalRow0 = colsRow0.find((c) => String(c.coluna).toUpperCase().trim() === 'TOTAL');
        var colsNoTotalRow0 = colsRow0.filter((c) => String(c.coluna).toUpperCase().trim() !== 'TOTAL');

        var rowBase = { "id": "base" };
        rowBase["lineName"] = "Base";

        if (typeof colTotalRow0 !== 'undefined') {
            rowBase["totalCol"] = Intl.NumberFormat('pt-PT', { useGrouping: true, }).format(colTotalRow0.base || 0);
        }

        for (let i = 0; i < colsNoTotalRow0.length; i++) {
            colFieldIndex = "col" + (i + 2);
            var base = colsNoTotalRow0[i].base;
            result = Intl.NumberFormat('pt-PT', { useGrouping: true, }).format(base || 0);
            rowBase[colFieldIndex] = result;
        }

        rowsAux[index] = rowBase;
        index++;

        if (this.props.media) {
            var rowMedia = { "id": "media" };
            rowMedia["lineName"] = "Média";
            if (typeof colTotalRow0 !== 'undefined') {
                rowMedia["totalCol"] = Intl.NumberFormat('pt-PT', { useGrouping: true, minimumFractionDigits: 2 }).format(parseFloat(colTotalRow0.media || 0).toFixed(2));
            }
            for (let i = 0; i < colsNoTotalRow0.length; i++) {
                colFieldIndex = "col" + (i + 2);
                var media = colsNoTotalRow0[i].media;
                result = Intl.NumberFormat('pt-PT', { useGrouping: true, minimumFractionDigits: 2 }).format(parseFloat(media || 0).toFixed(2));
                rowMedia[colFieldIndex] = result;
            }
            rowsAux[index] = rowMedia;
        } else if (this.props.nps) {
            var rowNps = { "id": "nps" };
            rowNps["lineName"] = "Net Promoter Score";
            if (typeof colTotalRow0 !== 'undefined') {
                rowNps["totalCol"] = Intl.NumberFormat('pt-PT', { useGrouping: true, }).format(parseFloat(colTotalRow0.nps || 0).toFixed(0));
            }
            for (let i = 0; i < colsNoTotalRow0.length; i++) {
                colFieldIndex = "col" + (i + 2);
                var nps = colsNoTotalRow0[i].nps;
                result = Intl.NumberFormat('pt-PT', { useGrouping: true, }).format(parseFloat(nps || 0).toFixed(0));
                rowNps[colFieldIndex] = result;
            }
            rowsAux[index] = rowNps;
        }

        return rowsAux; // Retornar diretamente!
    }

    initializeState = async () => {
    const newRowData = this.buildTableData();
    const colData = this.setColumnDefs(newRowData); // Passamos o newRowData para ele conseguir calcular a largura

    this.setState({
        studyName: this.props.studyName,
        nomeQuadro: this.props.nomeQuadro,
        dataTypeName: this.props.dataTypeName,
        column: this.props.column,            
        data: this.props.data,
        media: this.props.media,
        nps: this.props.nps,
        textoBase: this.props.textoBase,
        textoNota: this.props.textoNota,
        precision: this.props.precision,
        rowData: newRowData,
        columnDefs: colData.columnDefs,
        columns: colData.columns,
        topColumn: colData.topColumn,
        displayTable: newRowData && newRowData.length > 0 // A magia final que faz a tabela aparecer!
    });
}

    componentDidUpdate = async (prevProps) => {
        await this.props.data;
        if (typeof this.props.data !== 'undefined' && this.props.data !== prevProps.data) {
            this.setState({ nps: this.props.nps });
            this.setState({ media: this.props.media });
            this.initializeState();
        }
    }

    componentDidMount = async () => {
        await this.props.data;
        this.initializeState();
    }

    render() {
        return (
            <div id="tabulator-div-parent">
                {this.state.displayTable &&
                    <div>
                        <TableToExcel
                            title1={this.state.studyName}
                            title2={this.state.nomeQuadro}
                            dataTypeName={this.state.dataTypeName}
                            columns={this.state.columns}
                            rowData={this.state.rowData}
                            textoBase={this.state.textoBase}
                            textoNota={this.state.textoNota}
                            topColumn={this.state.topColumn}
                            filtrosArray={[]}
                        />
                    </div>
                }
                {this.state.displayTable &&
                    <div>
                        <TabulatorSoftdata
                            rowData={this.state.rowData}
                            columnDefs={this.state.columnDefs}
                            columns={this.state.columns} />

                    </div>
                }

                {this.state.displayTable && this.state.textoBase !== "" &&
                    <div style={{ width: "900px", marginLeft: "auto", marginRight: "auto", textAlign: "left" }}>
                        <span style={{ fontSize: "14px" }}><strong>Base:</strong> {parse(this.state.textoBase)}</span>
                    </div>
                }
                {this.state.displayTable && this.state.textoNota !== "" &&
                    <div style={{ width: "900px", marginLeft: "auto", marginRight: "auto", textAlign: "left" }}>
                        <span style={{ fontSize: "14px" }}><strong>Nota:</strong> {parse(this.state.textoNota)}</span>
                    </div>
                }

                {
                    this.state.rowData.length === 0 &&
                    <div>
                        <center>
                            <h4>Não existem dados.</h4>
                        </center>
                    </div>
                }
                <br />
                <hr />
                <br />
            </div>
        );
    }

}

export default DatatableReports;